import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetPaymentTransactionByIdQuery } from "../../payment-transactions.service";
import { PaymentTransactionDetails } from "../../components/payment-transaction-details";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

const PaymentTransactionDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToTransactions = appendSearchToPath("/payment-transactions", location.search);
  const { data: transaction, isLoading, isError, error } = useGetPaymentTransactionByIdQuery(id || "");

  if (isLoading) return <div className="p-6">Loading...</div>;
  if (isError || !transaction) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
            <h2 className="text-2xl font-bold text-red-800 mb-4">Payment Transaction Not Found</h2>
            <p className="text-red-600 mb-6">{typeof error === "object" && error ? "Could not load payment transaction" : ""}</p>
            <button onClick={() => navigate(backToTransactions)} className="px-6 py-3 bg-red-600 text-white rounded-lg">
              Back to Payment Transactions
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <PaymentTransactionDetails transaction={transaction} onBack={() => navigate(backToTransactions)} />;
};

export default PaymentTransactionDetailsPage;
